import { useDispatch, useSelector } from "react-redux";
import styles from "./EditFavouritePopUp.module.scss";
import { Button } from "../../../../components/Button";
import { CHANGE_NAME_VIEW } from "../../../../constants";
import EditIcon from "../../../../assets/icons/edit_icon.svg";
import DeleteIcon from "../../../../assets/icons/delete_icon.svg";
import { sendAnalyticsEvent, sendMessage } from "../../../../lib/postMessage";
import { DELETE, FAVOURITES } from "../../../../constants/analytics";

export function EditFavouritePopUp({ favourite }) {
  const dispatch = useDispatch();
  const { storedFavourites } = useSelector((state) => state.filter);
  const changeName = () => {
    dispatch({ type: "EDIT_FAVOURITE", payload: favourite });
    dispatch({
      type: "SET_ACTIVE_VIEW",
      payload: CHANGE_NAME_VIEW,
    });
  };

  const deleteFavourite = () => {
    const favourites = [...storedFavourites];
    const favouriteIndex = favourites.findIndex(
      (item) => item.id === favourite
    );

    const favouriteToDelete = favourites[favouriteIndex];

    favourites.splice(favouriteIndex, 1);

    sendMessage({
      type: "UpdateFavourites",
      payload: favourites,
    });

    // dispatch action to remove the favouriteToDelete from the prefetchedFilters
    dispatch({
      type: "REMOVE_FAVOURITE_FROM_FILTER",
      payload: favouriteToDelete,
    });

    sendAnalyticsEvent({
      event: FAVOURITES,
      type:
        favouriteToDelete.type.charAt(0).toUpperCase() +
        favouriteToDelete.type.slice(1),
      action: DELETE,
    });
  };

  return (
    <div className={styles.editFavouritePopUp}>
      <Button styleClass={styles.changeNameButton} clickHandler={changeName}>
        <img height={20} width={20} src={EditIcon} alt="Change" /> Change name
      </Button>
      <Button
        styleClass={styles.deleteFavouriteButton}
        clickHandler={deleteFavourite}
      >
        <img height={20} width={20} src={DeleteIcon} alt="Delete" /> Delete
        Favourite
      </Button>
    </div>
  );
}
